import { ReactComponent as ForumIcon } from "../../assets/icons/forum.svg";
import { ReactComponent as GovIcon } from "../../assets/icons/governance.svg";
import { ReactComponent as DocsIcon } from "../../assets/icons/docs.svg";
import { ReactComponent as FeedbackIcon } from "../../assets/icons/feedback.svg";
import { ReactComponent as BugBountyIcon } from "../../assets/icons/social4.svg";
import { ReactComponent as GrantsIcon } from "../../assets/icons/social5.svg";
import { SvgIcon } from "@material-ui/core";
import { Trans } from "@lingui/macro";

const externalUrls = [
  {
    title: <Trans>Forum</Trans>,
    url: "",
    icon: <SvgIcon color="inherit" component={ForumIcon} />,
  },
  {
    title: <Trans>Governance</Trans>,
    url: "",
    icon: <SvgIcon color="inherit" component={GovIcon} />,
  },
  {
    title: <Trans>Docs</Trans>,
    url: "",
    icon: <SvgIcon color="inherit" component={DocsIcon} />,
  },
  {
    title: <Trans>Bug Bounty</Trans>,
    url: "",
    icon: <SvgIcon color="inherit" component={BugBountyIcon} />,
  },
  {
    title: <Trans>Grants</Trans>,
    url: "",
    icon: <SvgIcon color="inherit" component={GrantsIcon} />,
  },
  // {
  //   title: <Trans>Docs</Trans>,
  //   url: "",
  //   icon: <SvgIcon color="inherit" component={DocsIcon} />,
  // },
  // {
  //   title: "Feedback",
  //   url: "https://olympusdao.canny.io/",
  //   icon: <SvgIcon color="inherit" component={FeedbackIcon} />,
  // },
];

export default externalUrls;
